import { render, staticRenderFns } from "./InviteUserModal.vue?vue&type=template&id=38e9c792&"
import script from "./InviteUserModal.vue?vue&type=script&lang=ts&"
export * from "./InviteUserModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports